import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from '../services/base.service';
import { StudentService } from '../services/student.service';

@Injectable({
    providedIn: 'root'
})

export class StudentResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: StudentService,
        private baseService: BaseService
    ) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ApiObjectData> {
        return this.baseService.resolveGet(this.service, route, '/page/students');
    }
}

@Injectable({
    providedIn: 'root'
})

export class StudentsResolver implements Resolve<ApiObjectData> {
    constructor(
        private service: StudentService,
        private baseService: BaseService
    ) { }
    resolve(): Observable<ApiObjectData> {
        return this.baseService.resolveGets(this.service);
    }
}